import { LoginPage } from '@/pages/login-page';
import type { ReactElement } from 'react';
import { AuthenticationGate } from './AuthenticationGate';
import { PriceEventQueueMonitor } from './price-event-queue-monitor';

export const AuthGuard = (): ReactElement => {
  return (
    <AuthenticationGate loginComponent={LoginPage}>
      <PriceEventQueueMonitor />
    </AuthenticationGate>
  );
};
